import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";
import moment from 'moment';

@Component({
    selector: 'app-app-for-day-chart',
    templateUrl: './app-for-day-chart.component.html',
    styleUrls: ['./app-for-day-chart.component.scss']
})
export class AppForDayChartComponent implements OnInit {

    @Input() titleText = 'Application/giorno';

    @Input() set appForDay(val: any) {
        if (val) {
            this.applicationDashboard = {
                chart: {
                    toolbar: {
                        show: true
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                colors: ['#64748B', '#94A3B8'],
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [0],
                    background: {
                        borderWidth: 0
                    }
                },
                grid: {
                    borderColor: 'var(--fuse-border)'
                },
                labels: val.labels,
                legend: {
                    show: false
                },
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                series: [
                    {
                        name: 'Nuove Application',
                        type: 'line',
                        data: val.series
                    },
                ],
                // states: {
                //     hover: {
                //         filter: {
                //             type: 'darken',
                //             value: 0.75
                //         }
                //     }
                // },
                stroke: {
                    width: [3, 0]
                },
                // tooltip    : {
                //   followCursor: true,
                //   theme       : 'dark'
                // },
                xaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        color: 'var(--fuse-border)'
                    },
                    labels: {
                        style: {
                            colors: 'var(--fuse-text-secondary)'
                        },
                        // formatter: function(val) {
                        //     return moment(val).format('dd MMM')
                        // },
                        // format: 'dd MMM'
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    labels: {
                        offsetX: -16,
                        style: {
                            colors: 'var(--fuse-text-secondary)'
                        }
                    }
                }
            };
        }
    }

    @Input() generalData: any;

    applicationDashboard: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {

    }

}
